<template>
  <AlertDialog v-model:open="dialogIsOpen">
    <AlertDialogTrigger class="flex items-center gap-2 cursor-pointer w-full">
      <slot name="trigger"></slot>
    </AlertDialogTrigger>
    <AlertDialogContent class="w-full max-w-sm lg:max-w-2xl">
      <AlertDialogHeader>
        <AlertDialogTitle>
          <slot name="title"></slot>
        </AlertDialogTitle>
        <AlertDialogDescription>
          <slot name="subtitle"></slot>
        </AlertDialogDescription>
      </AlertDialogHeader>
      <div class="my-2 overflow-y-auto p-4">
        <slot />
      </div>
      <AlertDialogFooter class="flex justify-end gap-[15px] border-gray-100">
        <AlertDialogCancel> Cancel </AlertDialogCancel>
        <AlertDialogAction :disabled="!selectedReason" @click="closeDialog"> Confirm </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
</template>

<script setup lang="ts">
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@/foundation/alert-dialog'

const dialogIsOpen = defineModel<boolean>()

defineProps<{ selectedReason?: string | null }>()

const emit = defineEmits(['closeDialog'])

const closeDialog = () => {
  emit('closeDialog')
}
</script>

<style scoped>
/* Add any additional styles here */
</style>
